import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import tableLoteryReportView from 'jet-views/reports/loteryReport/tableLoteryReport'; // Importing a specific view for lottery reports

/**
 * Class representing the details view of a lottery report.
 * @extends JetView
 */
export default class detailsLoteryReportView extends JetView {
    /**
     * Configures the layout of the details lottery report view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Main information section with ID, Transaction ID, Type, and Amount fields
        const main_info = {
            margin: 10,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Id'),
                    invalidMessage: _('A ID is required'), // Validation message
                    readonly: true, // Read-only field
                },
                {
                    view: 'text',
                    name: 'TransactionId',
                    label: _('Transacción Id'),
                    labelPosition: 'top',
                    placeholder: _('Transacción Id'),
                    readonly: true,
                },
                {
                    view: 'text',
                    name: 'Type',
                    label: _('Tipo'),
                    labelPosition: 'top',
                    placeholder: _('Tipo'),
                    readonly: true,
                },
                {
                    view: 'text',
                    name: 'Amount',
                    label: _('Valor'),
                    labelPosition: 'top',
                    placeholder: _('Valor'),
                    readonly: true,
                    id: 'Valor', // ID for accessing this field later
                },
            ],
        };

        // Second main information section with Value and Response fields
        const second_main_info = {
            margin: 10,
            rows: [
                {
                    view: 'textarea',
                    name: 'Value',
                    label: _('Envió'),
                    labelPosition: 'top',
                    placeholder: _('Envió'),
                    readonly: true,
                },
                {
                    view: 'textarea',
                    name: 'Response',
                    label: _('Respuesta'),
                    labelPosition: 'top',
                    placeholder: _('Respuesta'),
                    readonly: true,
                },
            ],
        };

        // Left main section layout
        const left_main = {
            gravity: 3,
            minWidth: 100,
            margin: 10,
            rows: [main_info],
        };

        // Right main section layout
        const rigth_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [second_main_info],
        };

        // Upper section layout with multiview and scroll
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main, { gravity: 1, minWidth: 20 }, rigth_main],
        };

        // Narrow upper section layout for smaller screens
        const upper_section_narrow = {
            padding: 10,
            rows: [main_info],
        };

        // Window configuration for detailed casino view
        const detailsCasino = webix.ui({
            view: 'window',
            move: true,
            id: 'detailsCasino',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'),
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close window on icon click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'dtDetails2',
                type: 'clean',
                rows: [upper_section_narrow],
            },
        });

        // Main return configuration for the form
        return {
            view: 'form',
            id: 'formDetails',
            rows: [
                screen !== 'small' ? upper_section : { height: 1, width: 0 }, // Conditional rendering based on screen size
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance to initialize.
     */
    init(form) {
        this.on(this.app, 'casinoTransDetail:select', (person) => {
            if (screen.width > 500 && screen.height > 500) {
                form.setValues(person); // Set form values for larger screens
                this.$$('Valor').setValue(
                    webix.i18n.priceFormat(person.Amount), // Format and set the Amount value
                );
            } else {
                $$('dtDetails2').setValues(person); // Set values for smaller screens
            }
        });
    }
}

// FILE DOCUMENTED
